export default __webpack_public_path__ + "static/media/1358.d69b83fc.png";